import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ_ITEMS } from "@/lib/content";

export default function FAQ() {
  return (
    <section className="relative py-16 md:py-24 lg:py-32 bg-[#050505]" id="faq" data-testid="faq-section">
      <div className="max-w-5xl mx-auto px-6 lg:px-12">
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-[#FFD60A]" />
            <span className="font-mono text-xs tracking-[0.4em] text-[#FFD60A] uppercase">F.A.Q.</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-white uppercase leading-[0.95]">
            Questions <span className="text-[#FFD60A]">fréquentes</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="border-t border-zinc-800">
          {FAQ_ITEMS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="border-b border-zinc-800"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="py-6 hover:no-underline group text-left">
                <span className="font-display text-xl md:text-2xl text-white uppercase tracking-wide group-hover:text-[#FFD60A] transition-colors pr-6">
                  {f.q}
                </span>
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-zinc-400 leading-relaxed text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
